const state = () => ({
  isValid: false,
  ico: ''
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  ico(state) {
    return state.ico;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updateICO(state, payload) {
    state.ico = payload;
  },
  resetStore(s) {
    Object.assign(s, state());
  }
};

const actions = {
  updateICO({ commit }, payload) {
    commit('updateICO', payload);
  }
};

export const ico = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
